import React, { useState } from "react";
import { Modal } from "semantic-ui-react";
import { Flex, Text, Button, Box } from "rebass";
import { Input } from "@rebass/forms";
import { apiService } from "../../apiService";
import { authHeader } from "../../session";
import { Icon } from "semantic-ui-react";

import SuccessModal from "./SuccessModal";
import ConfirmDialog from "./ConfirmDialog";
import handleUnauthorizedError from "../../handleUnauthorizedError";

function ChangePasswordModal({
  showChangePasswordModal,
  setShowChangePasswordModal,
  setShowMenu,
}) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showComplete, setShowComplete] = useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState(false);
  const [showComfirmDialog, setShowComfirmDialog] = useState(false);

  const [seeCurrentPassword, setSeeCurrentPassword] = useState(false);
  const [seeNewPassword, setSeeNewPassword] = useState(false);
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);

  const togglePassword = (passwordField) => {
    if (passwordField === "currentPassword") {
      setSeeCurrentPassword(!seeCurrentPassword);
    }
    if (passwordField === "newPassword") {
      setSeeNewPassword(!seeNewPassword);
    }
    if (passwordField === "confirmPassword") {
      setSeeConfirmPassword(!seeConfirmPassword);
    }
  };

  const closeModal = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setCurrentPasswordError("");
    setShowComplete(false);
    setShowChangePasswordModal(false);
    setShowComfirmDialog(false);
    setShowMenu(false);
    setSeeConfirmPassword(false);
    setSeeCurrentPassword(false);
    setSeeNewPassword(false);
  };

  const closeConfirmModal = () => {
    setShowComfirmDialog(false);
  };

  const changePassword = async () => {
    let req = {
      current_password: currentPassword,
      new_password: newPassword,
    };
    await apiService
      .post(`/auth/change-password`, req, authHeader())
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setShowComplete(true);
        }
      })
      .catch((err) => {
        handleUnauthorizedError(err, changePassword);
        setCurrentPasswordError(true);
      });
  };

  const validateNewPassword = () => {
    if (!newPassword) {
      return false;
    }
    if (newPassword.length < 6) {
      return false;
    }
    if (newPassword.search(/[a-z]/i) < 0) {
      return false;
    }
    if (newPassword.search(/[0-9]/) < 0) {
      return false;
    }
    if (newPassword.search(/(?!.* )/) > 0) {
      return false;
    }
    if (newPassword.search(/(?!.*[ก-๛])/) > 0) {
      return false;
    }
    return true;
  };

  return (
    <Modal
      size={"tiny"}
      onClose={() => setShowComfirmDialog(true)}
      onOpen={() => setShowChangePasswordModal(true)}
      closeOnDimmerClick={true}
      open={showChangePasswordModal}
    >
      <Modal.Header>
        <Text
          color="#003A66"
          textAlign={"center"}
          fontFamily="Mitr"
          fontWeight={400}
          fontSize={20}
        >
          เปลี่ยนรหัสผ่าน
        </Text>
      </Modal.Header>
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Flex
          flexDirection={"column"}
          width={8 / 10}
        >
          <Flex
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            my={20}
          >
            <Text
              mb={"4px"}
              color={"#38454D"}
              fontFamily="Mitr"
              fontWeight={400}
            >
              รหัสผ่านปัจจุบัน
            </Text>
            <Flex
              pr={"8px"}
              alignItems={"center"}
              width={"100%"}
              sx={{
                outline: "none",
                borderRadius: "8px",
                border: "1px solid #eee",
                boxShadow:
                  "0px 0.0851744px 0.255523px rgba(0, 0, 0, 0.1), 0px 0.851744px 1.70349px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Input
                sx={{
                  outline: "none",
                  border: "none",
                }}
                onChange={(e) => {
                  setCurrentPassword(e.target.value);
                  setCurrentPasswordError(false);
                }}
                type={seeCurrentPassword ? "text" : "password"}
              ></Input>
              <Box
                color="#003A66"
                onClick={() => {
                  togglePassword("currentPassword");
                }}
              >
                <Icon name={seeCurrentPassword ? "eye slash" : "eye"}></Icon>
              </Box>
            </Flex>
          </Flex>
          <Flex
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            mb={12}
          >
            <Text
              mb={"4px"}
              fontFamily="Mitr"
              fontWeight={400}
              color={"#38454D"}
            >
              รหัสผ่านใหม่
            </Text>
            <Flex
              pr={"8px"}
              alignItems={"center"}
              width={"100%"}
              sx={{
                outline: "none",
                borderRadius: "8px",
                border: "1px solid #eee",
                boxShadow:
                  "0px 0.0851744px 0.255523px rgba(0, 0, 0, 0.1), 0px 0.851744px 1.70349px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Input
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setCurrentPasswordError(false);
                }}
                type={seeNewPassword ? "text" : "password"}
                sx={{
                  outline: "none",
                  border: "none",
                }}
              ></Input>
              <Box
                color="#003A66"
                onClick={() => {
                  togglePassword("newPassword");
                }}
              >
                <Icon name={seeNewPassword ? "eye slash" : "eye"}></Icon>
              </Box>
            </Flex>
          </Flex>
          {!!newPassword && !validateNewPassword() && (
            <Text
              mb={10}
              color={"#D21C1C"}
              fontFamily="Mitr"
              fontWeight={400}
            >
              รหัสผ่านใหม่ต้องมีความยาวอย่างน้อย 6 ตัวอักษร
              โดยประกอบไปด้วยตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัวและตัวเลขอย่างน้อย
              1 ตัว และไม่สามารถประกอบไปด้วยตัวอักษรภาษาไทยและช่องว่างได้
            </Text>
          )}

          <Flex
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            mb={16}
          >
            <Text
              mb={"4px"}
              fontFamily="Mitr"
              fontWeight={400}
              color={"#38454D"}
            >
              ยืนยันรหัสผ่านใหม่
            </Text>
            <Flex
              backgroundColor={validateNewPassword() ? "white" : "#EEE"}
              pr={"8px"}
              alignItems={"center"}
              width={"100%"}
              sx={{
                outline: "none",
                borderRadius: "8px",
                border: "1px solid #eee",
                boxShadow:
                  "0px 0.0851744px 0.255523px rgba(0, 0, 0, 0.1), 0px 0.851744px 1.70349px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Input
                disabled={!validateNewPassword()}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setCurrentPasswordError(false);
                }}
                type={seeConfirmPassword ? "text" : "password"}
                sx={{
                  outline: "none",
                  border: "none",
                }}
              ></Input>
              <Box
                color={validateNewPassword() ? "#003A66" : "#A7A7A7"}
                sx={{
                  pointerEvents:
                    newPassword.length >= 6 &&
                    newPassword.match(/\d/) &&
                    isNaN(newPassword)
                      ? "unset"
                      : "none",
                }}
                onClick={() => {
                  togglePassword("confirmPassword");
                }}
              >
                <Icon name={seeConfirmPassword ? "eye slash" : "eye"}></Icon>
              </Box>
            </Flex>
          </Flex>

          {confirmPassword !== "" && confirmPassword !== newPassword ? (
            <Text
              mb={10}
              color={"#D21C1C"}
              fontFamily="Mitr"
              fontWeight={400}
            >
              ยืนยันรหัสผ่านใหม่ไม่ถูกต้อง
            </Text>
          ) : null}
          {currentPasswordError ? (
            <Text
              mb={10}
              color={"#D21C1C"}
              fontFamily="Mitr"
              fontWeight={400}
            >
              รหัสผ่านปัจจุบันไม่ถูกต้อง
            </Text>
          ) : null}
        </Flex>
      </Flex>
      <Modal.Actions>
        <Button
          onClick={() => {
            changePassword();
          }}
          disabled={
            !confirmPassword ||
            !newPassword ||
            confirmPassword !== newPassword ||
            !validateNewPassword()
          }
          fontSize={16}
          fontFamily="Mitr"
          fontWeight={300}
          backgroundColor={
            !confirmPassword ||
            !newPassword ||
            confirmPassword !== newPassword ||
            !validateNewPassword()
              ? "#A7A7A7"
              : "#206ed1"
          }
          width={160}
          height={48}
          alignSelf="center"
          css={{
            borderRadius: "14px",
            "&:hover": {
              backgroundColor:
                !confirmPassword ||
                !newPassword ||
                confirmPassword !== newPassword ||
                !validateNewPassword()
                  ? "#A7A7A7"
                  : "#005ED2",
            },
          }}
        >
          เปลี่ยนรหัสผ่าน
        </Button>
      </Modal.Actions>
      <SuccessModal
        open={showComplete}
        onClose={closeModal}
        text={"เปลี่ยนรหัสผ่านสำเร็จ"}
      ></SuccessModal>
      <ConfirmDialog
        showConfirmDialog={showComfirmDialog}
        title={"คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้"}
        message={"การเปลี่นนรหัสผ่านของคุณยังไม่ได้รับการบันทึก"}
        cancelButtonTitle={"ใช่"}
        confirmButtonTitle={"ยกเลิก"}
        onCancel={closeModal}
        onConfirm={closeConfirmModal}
      ></ConfirmDialog>
    </Modal>
  );
}

export default ChangePasswordModal;
